module.exports = __webpack_public_path__ + "img/74.1bcff74f.jpg";